import { Search, Send, Users, Zap } from "lucide-react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import FeatureItem from "./FeatureItem";

//TODO: Replace constants here or pipe in props from Process page.

const FeatureItemsStrip = () => {
  return (
    <Row className="gy-4 gx-5">
      <Col xs={6} md={3} lg={3}>
        <FeatureItem size={35} icon={<Users size={30}/>} imgAlt="Lightbulb"
          text="Ask and Prepare"></FeatureItem>
      </Col>
      <Col xs={6} md={3} lg={3}>
        <FeatureItem size={35} icon={<Search size={30}/>} imgAlt="Diamond"
          text="Process and Analyze" />
      </Col>
      <Col xs={6} md={3} lg={3}>
        <FeatureItem size={35} icon={<Send size={30}/>} imgAlt="Paper plane"
          text="Visualize and Share" />
      </Col>
      <Col xs={6} md={3} lg={3}>
        <FeatureItem size={35}icon={<Zap size={30}/>} imgAlt="Snowflake"
          text="Act" />
      </Col>
    </Row>
  );
}

export default FeatureItemsStrip;
